// extracted by mini-css-extract-plugin
export default {"form_control":"AuthSignUp_form_control__WMwSb","form_control__login":"AuthSignUp_form_control__login__4jb6D","signUp_link":"AuthSignUp_signUp_link__Uf2Hp"};